import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "px-4 py-5" }
const _hoisted_4 = {
  key: 2,
  class: "flex items-end gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex mt-4"
}
const _hoisted_6 = { class: "w-2 h-5" }

import { RichText, Link, Image } from '@sitecore-jss/sitecore-jss-vue';
import { IPromoCardImageItem } from '@/interfaces/entities/promo-card-image.interface';
import Tag from '@/components/Tag/Tag.vue';
import { TagBgColour, TagSize, TagTypes } from '@/enums/tag-enums';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardImageContent',
  props: {
    promoCardImage: {},
    isWrappedInLink: { type: Boolean },
    tagSize: {},
    tagBgColour: {},
    tagTypes: {},
    getMaxImageWidthClasses: { type: Function },
    getBackgroundColourClass: { type: Function },
    isValidPrimaryButton: { type: Function },
    isValidSecondaryButton: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'flex flex-col rounded-lg',
        _ctx.getMaxImageWidthClasses(),
        { 'border-[1.5px] border-racq-pale-grey': _ctx.promoCardImage.fields.showBorder.value },
        _ctx.getBackgroundColourClass(_ctx.promoCardImage.fields.backgroundColour),
      ])
    }, [
      (_ctx.promoCardImage.fields.image.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(Image), {
              media: _ctx.promoCardImage.fields.image,
              class: "w-full h-auto rounded-t-lg"
            }, null, 8, ["media"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.promoCardImage.fields.tag.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
              'text-m-bold text-racq-dark-grey pb-2',
              { 'text-center': !_ctx.promoCardImage.fields.showBorder.value },
            ])
            }, [
              (!_ctx.promoCardImage.fields.tagIsText.value)
                ? (_openBlock(), _createBlock(Tag, {
                    key: 0,
                    tagSize: _unref(TagSize).xs,
                    tagBgColour: 
                  _ctx.promoCardImage.fields.showPurpleTag?.value ? _unref(TagBgColour).lightHighlightPurple : _unref(TagBgColour).infoBlue
                ,
                    tagText: _ctx.promoCardImage.fields.tag.value,
                    tagType: _ctx.promoCardImage.fields.showPurpleTag?.value ? _unref(TagTypes).purpleStar : _unref(TagTypes).star
                  }, null, 8, ["tagSize", "tagBgColour", "tagText", "tagType"]))
                : _createCommentVNode("", true),
              (_ctx.promoCardImage.fields.tagIsText.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 1,
                    field: _ctx.promoCardImage.fields.tag
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.promoCardImage.fields.title.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([
              'text-lg-bold text-racq-dark-grey pb-1 group-active:underline group-active:text-racq-navy',
              { 'text-center': !_ctx.promoCardImage.fields.showBorder.value },
            ])
            }, [
              _createVNode(_unref(RichText), {
                field: _ctx.promoCardImage.fields.title
              }, null, 8, ["field"])
            ], 2))
          : _createCommentVNode("", true),
        (
            _ctx.promoCardImage.fields.description.value ||
            (_ctx.promoCardImage.fields.isChevron.value && _ctx.promoCardImage.fields.chevronUrl.value)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.promoCardImage.fields.description.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['text-m text-racq-med-grey', { 'text-center': !_ctx.promoCardImage.fields.showBorder.value }])
                  }, [
                    _createVNode(_unref(RichText), {
                      class: _normalizeClass(_ctx.promoCardImage?.fields?.descriptionClass?.value),
                      field: _ctx.promoCardImage.fields.description
                    }, null, 8, ["class", "field"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.promoCardImage.fields.isChevron.value && _ctx.promoCardImage.fields.chevronUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                    _ctx.promoCardImage.fields?.isChevronRoundedBorder?.value
                      ? 'border-[1.5px] border-racq-light-blue-grey'
                      : 'promo-card-image-chevron-border'
                  , "w-8 h-8 rounded-[40px] inline-flex justify-center items-center"])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(BaseIcon, {
                          iconClass: "bg-icon-chevron",
                          class: "!w-4 !h-4"
                        })
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            !_ctx.promoCardImage.fields.isChevron.value &&
            !_ctx.isWrappedInLink &&
            (_ctx.isValidPrimaryButton(_ctx.promoCardImage) || _ctx.isValidSecondaryButton(_ctx.promoCardImage))
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([
              'flex flex-wrap mt-4 flex-start gap-4',
              { 'justify-center': !_ctx.promoCardImage.fields.showBorder.value },
            ])
            }, [
              (_ctx.isValidPrimaryButton(_ctx.promoCardImage))
                ? (_openBlock(), _createBlock(_unref(Link), {
                    key: 0,
                    field: _ctx.promoCardImage.fields.primaryButton.value,
                    class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${_ctx.promoCardImage.fields.primaryButton.value.class}`),
                    "aria-label": _ctx.promoCardImage.fields.primaryButton?.value.text
                  }, null, 8, ["field", "class", "aria-label"]))
                : _createCommentVNode("", true),
              (_ctx.isValidSecondaryButton(_ctx.promoCardImage))
                ? (_openBlock(), _createBlock(_unref(Link), {
                    key: 1,
                    field: _ctx.promoCardImage.fields.secondaryButton,
                    class: _normalizeClass(`flex px-3 py-1.5 justify-center items-center self-stretch text-base btn btn-sm ${_ctx.promoCardImage.fields.secondaryButton?.value.class}`),
                    "aria-label": _ctx.promoCardImage.fields.secondaryButton.value.text
                  }, null, 8, ["field", "class", "aria-label"]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})